module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Expression",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35,53.5714286 C22.3025949,53.5714286 5,46.4285714 5,29.2857143 C5,15.8731025 18.4314575,5 35,5 C51.5685425,5 65,15.8730846 65,29.2857143 C65,35.9299463 61.7691465,42.0437407 56.4285714,46.4285714 C56.4285714,50.7142857 59.4086565,53.5714286 60.7142857,55 C57.9071917,55 50.8213588,52.1690151 49.2857143,50.7109895 C45.0203052,52.5481664 40.1701105,53.5714286 35,53.5714286 Z M33.0982143,38.7745098 C33.8592595,38.7745098 36.9685832,38.7745098 37.7589286,38.7745098 C37.7589286,38.0542172 37.7589286,35.7943568 38.5357143,34.9754902 C40.0832826,33.3440852 41.6428571,31.9037493 41.6428571,29.6568627 C41.6428571,26.2998378 38.8606267,23.5784314 35.4285714,23.5784314 C31.9965162,23.5784314 29.2142857,26.2998378 29.2142857,29.6568627 C29.2142857,31.91209 30.780035,33.318002 32.3214286,34.9754902 C33.0982143,35.8107818 33.0982143,38.0401192 33.0982143,38.7745098 Z M33.0982143,40.2941176 C33.0982143,42.3202614 33.3571429,43.3333333 33.875,43.3333333 C34.6517857,43.3333333 36.2205762,43.3333333 36.981005,43.3333333 C37.4879575,43.3333333 37.7472654,42.3202614 37.7589286,40.2941176 L33.0982143,40.2941176 Z M23,29.6568627 L23,31.1764706 L26.8839286,31.1764706 L26.8839286,29.6568627 L23,29.6568627 Z M34.6517857,17.5 L34.6517857,21.2990196 L36.2053571,21.2990196 L36.2053571,17.5 L34.6517857,17.5 Z M45.2298452,21.5760583 L41.9397977,23.4755682 L42.7165834,24.8210005 L46.0066309,22.9214907 L45.2298452,21.5760583 Z M25.6272977,21.5760583 L24.850512,22.9214907 L28.1405595,24.8210005 L28.9173452,23.4755682 L25.6272977,21.5760583 Z M43.9732143,29.6568627 L43.9732143,31.1764706 L47.8571429,31.1764706 L47.8571429,29.6568627 L43.9732143,29.6568627 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4486dd9b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/expression.vue
// module id = 616
// module chunks = 1